<template>
  <div>
    <el-row type="flex" align="middle">
      <div :class="['left-option-header', leftShadow ? 'left-shadow' : '']">
        <div class="left-option-header-title">
          {{title}}
          <span class="left-option-header-time">
            {{numDays}}
          </span>
        </div>

      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "option-header",
  props: {
    leftShadow: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
    },
    numDays:{
      type: String,
      default: ''
    },
    isShowSelect:{
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style scoped>
.left-option-header-title{
  /*margin-bottom: 16px;*/
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.left-option-header-select{

}
.left-option-header-time{
  display: inline-block;
  margin-left: 10px;
  font-size: 12px;
  color: #888;
  font-weight: 500;
}
.left-option-header {
  /*background: #fff;*/
  margin-top: 10px;
}
.left-shadow {
  /*box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);*/
}
</style>